export default __webpack_public_path__ + "static/imda20183rdprizeschool-1a9ae51ac5bff5880e42015c34eb6640.jpg";